<template>
  <div class="container mt-10 text-center">
    <loading
            v-model:active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
          />
    <div class="head-title pb-0 px-4" v-if="info">
      <h2 class="text-capitalize">{{info.asset.name}}</h2>
    </div>
    <div class="details-section mt-3" v-if="info && !isLoading">
      <div class="row no-gutters">
        <div class="col-md-4 mt-4">
          <div class="card">
            <img
              class="card-img-top px-3 pt-3 pb-0"
              :src="getImgUrl(info.asset.immutable_data.img)"
              alt=""
            />
            <div class="card-body pt-0 mt-0">
              <h3 class="m-0 asset-name text-capitalize">{{info.asset.name}}</h3>
              <p class="card-text p-0 m-0">Price</p>
              <h5 class="p-0 m-0 ship-price">{{Number(parseFloat(info.price)).toFixed(2)}} DOUB</h5>
              <!-- <span>(${{Number(info.prices[0].average/100000000*0.3416).toFixed(2)}})</span> -->
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="ship-info h-100">
            <div class="container text-left py-3 px-5">
              <div class="row">
                <div class="col-md-6">
                  <div class="small-text">
                    <h6 class="grey-color">NFT Name</h6>
                    <h2>{{info.asset.name}}</h2>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">owner</h6>
                    <h5 class="owner-name font-weight-bold">
                      <a href="#" class="light-red">lostsailorsl</a>
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Mint number</h6>
                    <h5 class="text-white">
                      <span class="light-red">{{info.asset.issued_supply}}</span>
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Use</h6>
                    <h5 class="text-white">
                      <span class="light-red">{{info.asset.immutable_data.use || 0}}</span>
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Extra Power</h6>
                    <h5 class="id text-white font-weight-bold">
                      {{info.asset.immutable_data.extrapower || 0}}
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Extra Speed</h6>
                    <h5 class="id text-white font-weight-bold">
                      {{info.asset.immutable_data.extraspeed || 0}}
                    </h5>
                  </div>
                  <!-- <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">backed token</h6>
                    <h5 class="text-white font-weight-bold">{{info.backed_tokens.toString()}}</h5>
                  </div> -->
                  <div class="text-center">
                    <div class="links">
                      <a href="#">
                        <i class="fab fa-telegram-plane light-red"></i>
                      </a>
                      <a href="#">
                        <i class="fab fa-twitter light-red"></i>
                      </a>
                      <a href="#">
                        <i class="fa fa-link light-red"></i>
                      </a>
                    </div>
                    <h1 class="font-weight-bold text-white total-price font-2">
                      Price:
                      <span class="light-red text-uppercase price-color"
                        >{{Number(parseFloat(info.price)).toFixed(2)}} DOUB
                      </span>
                      <!-- <span class="text-white font-2 font-weight-light-1"
                        >(${{Number(info.prices[0].average/100000000*0.3416).toFixed(2)}})</span
                      > -->
                    </h1>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="small-text">
                    <h6 class="grey-color">Collocation name</h6>
                    <h2>{{info.asset.collection.collection_name}}</h2>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Schema name</h6>
                    <h5 class="font-weight-bold light-red">{{info.schema}}</h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Template ID</h6>
                    <h5 class="owner-name font-weight-bold light-red">
                      #{{info.asset_t}}
                    </h5>
                  </div>
                  <div class="small-text">
                    <h6 class="grey-color mb-0 pb-0">Property</h6>
                    <div class="d-flex align-items-center" v-if="info.asset.is_transferable">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                        />
                      </svg>
                      <h5 class="text-white font-weight-bold">Transferable</h5>
                    </div>
                  </div>
                  <div class="small-text" v-if="info.asset.is_burnable">
                    <div class="d-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z"
                          clip-rule="evenodd"
                        />
                      </svg>

                      <h5 class="text-white font-weight-bold">Burnable</h5>
                    </div>
                  </div>
                  <div class="bg-color rounded px-4 py-3 text-center">
                    <span class="font-weight-bold">Seller:</span>
                    <span class="accountName">
                      <img src="/lostsailor/images/wax.png" alt="" />
                      <a href="javaScript:void(0)" class="light-red">lostsailorsl</a>
                    </span>
                    <!-- <div class="text-center">
                      <span class="font-weight-bold text-capitalize">Trade offer ID:</span>
                      <a href="javaScript:void(0)" class="light-red mx-3">#{{info.sales.offer_id}}</a>
                    </div> -->
                  </div>
                  <div class="text-center mt-2">
                    <button class="btn btn-block btn-primary w-100" @click="buy(info.asset_t,info.price)">Buy</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="back-btn">
      <a href="#" @click="$router.go(-1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
import ApiService from '../services'
// import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { useToast } from 'vue-toastification'
const toast = useToast()
export default {
  name: "MarketDetails",
  components:{
    Loading
  },
  // computed: mapState(["market"]),
  data(){
    return {
      userFilter: null,
      info: null,
      isLoading: false,
      fullPage: true,
      status: false,
      assetId:"",
      row:{},
      assetIds:[],
      showModal: false,
      showStackModal: false,
      error:false,
      activeMenuSearch:false,
      activeMenu:false
    }
  },
  mounted() {
    this.init();
  },
  methods:{
    calculatePrice(price){
      return price;
      // return ApiService.calculatePrice(price[0]);
    },
    getImgUrl(hash){
      return ApiService.getImgUrl(hash);
    },
    init() {
      this.isLoading = true
      ApiService.market((res) => {
          this.info = res.filter(item => item.asset_t == this.$route.params.id)[0];
          this.loading = false;
          this.isLoading = false
      });
    },
    async buy(templateId,price){
      if(templateId && price){
          await ApiService.buy(
          {
            from: localStorage.getItem("wax_user"),
            to:process.env.VUE_APP_CONTRACT,
            quantity:price,
            memo: `${templateId}:1`,
          },
          (res) => {
            if (res.processed) {
              toast.success("Transaction processing.");
            }
          },
          (error) => {
            error = ApiService.errorFormat(error);
            toast.error(error);
          }
        );
        }else{
            this.error = "Please specify quantity";
            toast.error(this.error);
        }
    }
  }
};
</script>

<style>
.container .back-btn {
  float: right;
  margin-top: -10px;
  margin-left: 10px;
}
</style>